// ManagingFiles.js
import React from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';

export default function ManagingFiles() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        Managing&nbsp;Files
      </Typography>

      <Typography paragraph>
        Store recurring spreadsheets in PostSheet so campaigns can reuse them.
      </Typography>

      <List className="steps-vertical" sx={{ ml: '2rem' }}>
        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            1&nbsp;·&nbsp;<strong>Upload&nbsp;files</strong> — click&nbsp;<em>Upload&nbsp;Files</em>
            and add one or more&nbsp;<code>.xls</code>, <code>.xlsx</code> or&nbsp;<code>.csv</code>.
          </Typography>
             <Typography variant="h4">
            2&nbsp;·&nbsp;<strong>Files&nbsp;table</strong> — shows name, type, upload date and quick actions.
          </Typography>
          <img src="../../static/docs/uploadedfiles.jpg" alt="Files uploaded list" className="step-img" />
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            When you click details, your spreadsheet will be displayed
          </Typography>
          <img src="../../static/docs/filedetails.jpg" alt="File details" className="step-img" />
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            3&nbsp;·&nbsp;<strong>Delete&nbsp;selected</strong> — tick rows and press&nbsp;<em>Delete</em>.
          </Typography>
        </ListItem>
      </List>
    </Box>
  );
}
